module.exports = __webpack_public_path__ + "static/media/Cientista1.c682d408.jpg";